import { useContext, useState, useEffect } from "react";
import { DasboardContext } from "../../context/dashboard-context";
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import { useParams } from "react-router-dom";
import Table from "react-bootstrap/Table";
import { MdLocalDrink } from "react-icons/md";
import { IoFastFoodOutline } from "react-icons/io5";
import { RiStethoscopeFill } from "react-icons/ri";
import { FaShower, FaPersonFalling } from "react-icons/fa6";
import { Modal, Button, Form } from "react-bootstrap";
import {
	GiClothes,
	GiVacuumCleaner,
	GiRobotLeg,
	GiFingernail,
} from "react-icons/gi";
import { TbPhysotherapist } from "react-icons/tb";
import { FaTeeth } from "react-icons/fa";
import { FaEarDeaf, FaPeopleArrows } from "react-icons/fa6";
import Diaper from "./diaper.svg";
import Stand from "./stand.svg";
import { MdOutlineElderly } from "react-icons/md";
import { PiHeartbeatFill } from "react-icons/pi";
import { BsFillLungsFill } from "react-icons/bs";
import { FaBed, FaInfo } from "react-icons/fa";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { Range } from "react-range";

import "./style.css";

const Activities = () => {
	const { sidebarOpen, userInfo, bedData } = useContext(DasboardContext);
	const { id } = useParams();
	const [deviceDetail, setDeviceDetail] = useState();

	const [selectedActivityIndex, setSelectedActivityIndex] = useState(0);
	const [startDate, setStartDate] = useState("");
	const [times, setTimes] = useState("");
	const [endType, setEndType] = useState("");
	const [endDate, setEndDate] = useState("");
	const [occurrences, setOccurrences] = useState("");
	const [desc, setDesc] = useState("");
	const [activitiesData, setActivitiesData] = useState([""]);
	const [vitalLogs, setVitalLogs] = useState([]);

	const [reminderStartDate, reminderSetStartDate] = useState("");
	const [repeat, setRepeat] = useState("Günlük");
	const [selectedDays, setSelectedDays] = useState([]);
	const [customTime, setCustomTime] = useState(false);
	const [reminders, setReminders] = useState([]);
	const [time, setTime] = useState([]);

	const [vToken, setVToken] = useState("");
	const [residentId, setResidentId] = useState("");
	const [fallStatus, setFallStatus] = useState();

	const [fallModal, setFallModal] = useState(false);

	/** fall ayarlarını saklamak için config (API body ile uyumlu) */
	const [fallConfig, setFallConfig] = useState({
		state: false,
		profile: "low",
		minimumTimeInBedSeconds: 0,
		afterBedExitDelaySeconds: 0,
		always: false,
	});

	// ---------- HR THRESHOLDS (NEW) ----------
	const [hrModal, setHrModal] = useState(false);
	const HR_PRESETS = {
		low: { lowerBpm: 45, upperBpm: 120 },
		medium: { lowerBpm: 50, upperBpm: 115 },
		high: { lowerBpm: 55, upperBpm: 110 },
	};

	const [hrConfig, setHrConfig] = useState({
		state: false,
		profile: "high", // low | medium | high | custom
		lowerBpm: 55,
		upperBpm: 110,
		thresholds: {
			low: [{ limit: 55, minimumDurationSeconds: 15, type: null }],
			high: [{ limit: 110, minimumDurationSeconds: 15, type: null }],
		},
		periods: [],
		measurement: false,
		measurementFrequency: null,
		id: "hr",
	});

	// ---------- RR THRESHOLDS (SOLUNUM HIZI - NEW) ----------
	const [rrModal, setRrModal] = useState(false);

	// RR slider sınırları
	const RR_MIN = 1;
	const RR_MAX = 50;
	const RR_STEP = 1;
	const RR_MIN_GAP = 1;
	const pctRR = (v) => ((v - RR_MIN) / (RR_MAX - RR_MIN)) * 100;

	// RR presetler (placeholder – istersen değiştirirsin)
	const RR_PRESETS = {
		low: { lower: 8, upper: 30 },
		medium: { lower: 10, upper: 28 },
		high: { lower: 12, upper: 26 },
	};

	const [rrConfig, setRrConfig] = useState({
		state: false,
		profile: "high", // low | medium | high | custom
		lower: 12,
		upper: 26,
		thresholds: {
			low: [{ limit: 12, minimumDurationSeconds: 15, type: null }],
			high: [{ limit: 26, minimumDurationSeconds: 15, type: null }],
		},
		periods: [],
		measurement: false,
		measurementFrequency: null,
		id: "rr",
	});

	// ---------- POSTURE (YATAK DOLULUK - BED OCCUPANCY) ----------
	const [postureModal, setPostureModal] = useState(false);
	const [postureStatus, setPostureStatus] = useState(null); // API'den gelen ham veri
	const [successModal, setSuccessModal] = useState(false);
	const [successMessage, setSuccessMessage] = useState("");

	const [postureConfig, setPostureConfig] = useState({
		inBed: {
			enabled: false,
			onlyDuringSleepTime: false,
		},
		outOfBed: {
			enabled: false,
			onlyDuringSleepTime: false,
		},
		awayFromBed: {
			enabled: false,
			onlyDuringSleepTime: false,
			delayMinutes: 1, // 1-120 dakika
		},
		minimumTimeInBedMinutes: 1, // 1-20 dakika
		sleepTime: {
			// Varsayılan uyku saatleri (resimdeki gibi)
			periods: [
				{ start: "19:30", end: "07:30" }, // 7:30 pm - 7:30 am
				{ start: "13:30", end: "16:30" }, // 1:30 pm - 4:30 pm
			],
		},
	});

	const days = ["P", "S", "Ç", "PŞ", "C", "CT", "PZ"];

	// Uyku saatlerini formatla (19:30 -> 7:30 pm)
	const formatSleepTime = (timeStr) => {
		if (!timeStr) return "";
		const [hours, minutes] = timeStr.split(":");
		const hour = parseInt(hours, 10);
		const ampm = hour >= 12 ? "pm" : "am";
		const displayHour = hour > 12 ? hour - 12 : hour === 0 ? 12 : hour;
		return `${displayHour}:${minutes} ${ampm}`;
	};

	const toggleDay = (day) => {
		if (selectedDays.includes(day)) {
			setSelectedDays(selectedDays.filter((d) => d !== day));
		} else {
			setSelectedDays([...selectedDays, day]);
		}
	};

	const handleReminderTimeChange = (index, value) => {
		const updatedTimes = [...time];
		updatedTimes[index] = value;
		setTime(updatedTimes);
	};

	const addReminder = () => {
		const newReminders = time.map((t) => {
			const targetDate = new Date(`${startDate}T${t}`);
			return {
				id: Date.now() + Math.random(),
				targetDate,
				repeat,
				selectedDays,
			};
		});

		setReminders((prev) => [...prev, ...newReminders]);
	};

	useEffect(() => {
		const interval = setInterval(() => {
			const now = new Date();

			reminders.forEach((reminder) => {
				const diff = reminder.targetDate - now;

				if (diff <= 0) {
					alert(
						`Hatırlatıcı zamanı geldi!\nTekrar: ${
							reminder.repeat
						}\nTarih: ${reminder.targetDate.toLocaleString()}`
					);

					setReminders((prev) => prev.filter((r) => r.id !== reminder.id));
				}
			});
		}, 1000);

		return () => clearInterval(interval);
	}, [reminders]);

	useEffect(() => {
		const fetchDeviceDetail = async () => {
			try {
				const response = await fetch(`https://app.vivasmartcare.com/api/devices/${id}`);
				if (!response.ok) {
					throw new Error("Veri alınamadı");
				}
				const data = await response.json();
				console.log(data);

				setDeviceDetail("data", data);
			} catch (error) {
				console.error("Hata:", error);
			}
		};

		fetchDeviceDetail();
	}, [id]);

	const addTime = () => {
		setTime([...time, "00:00"]);
	};

	const [riskLevel, setRiskLevel] = useState("low");
	const [alertDuringCare, setAlertDuringCare] = useState(false);
	const [minTimeInBed, setMinTimeInBed] = useState(20);
	const [enabled, setEnabled] = useState(false);

	const handleAddTime = () => {
		setTimes([...times, ""]);
	};

	const handleTimeChange = (index, value) => {
		const updated = [...times];
		updated[index] = value;
		setTimes(updated);
	};

	const activities = [
		{ name: "İçme", icon: <MdLocalDrink /> },
		{ name: "Yeme", icon: <IoFastFoodOutline /> },
		{ name: "Hayati Sinyaller", icon: <RiStethoscopeFill /> },
		{ name: "Banyo", icon: <FaShower /> },
		{ name: "Kıyafet Değişimi", icon: <GiClothes /> },
		{ name: "Fizyoterapi", icon: <TbPhysotherapist /> },
		{ name: "Oda Temizliği", icon: <GiVacuumCleaner /> },
		{ name: "Ağız Bakımı", icon: <FaTeeth /> },
		{ name: "İşitme Yardımı", icon: <FaEarDeaf /> },
		{ name: "Protez", icon: <GiRobotLeg /> },
		{ name: "Duruş Değişikliği", icon: <FaPeopleArrows /> },
		{ name: "Tırnak Kesimi", icon: <GiFingernail /> },
		{ name: "Bez Değişimi", icon: <img src={Diaper} alt="diaper" /> },
		{ name: "Ayakta", icon: <img src={Stand} alt="stand" /> },
		{ name: "Yürüyüş", icon: <MdOutlineElderly /> },
		{ name: "Bilgi", icon: <FaInfo /> },
	];

	const HR_MIN = 1;
	const HR_MAX = 180;
	const HR_STEP = 1;
	const HR_MIN_GAP = 1;
	const pct = (v) => ((v - HR_MIN) / (HR_MAX - HR_MIN)) * 100;

	const alarms = [
		{ name: "Düşme", icon: <FaPersonFalling /> },
		{ name: "Duruş Değişikliği", icon: <FaPeopleArrows /> },
		{ name: "Kalp Atış Hızı", icon: <PiHeartbeatFill /> },
		{ name: "Solunum Hızı", icon: <BsFillLungsFill /> },
		{ name: "Yatakta", icon: <FaBed /> },
	];

	const currentActivity = activities[selectedActivityIndex];

	async function addActivity(e) {
		e.preventDefault();

		try {
			const response = await fetch("https://app.vivasmartcare.com/api/add-activity", {
				method: "POST",
				body: JSON.stringify({
					deviceId: id,
					type: currentActivity.name,
					date: startDate,
					aTime: times,
					desc: desc,
					user: userInfo?.username,
				}),
				headers: { "Content-Type": "application/json" },
			});

			if (response.ok) {
				alert("Kayıt etkleme başarılı");
			} else {
				alert("Kayıt eklenirken bir hata oluştu");
			}
		} catch (error) {
			console.error("Ekleme işlemi sırasında bir hata oluştu:", error);
		} finally {
			window.location.reload();
		}
	}

	const fetchActivity = async () => {
		try {
			const response = await fetch(`https://app.vivasmartcare.com/api/activites/${id}`);
			const data = await response.json();
			setActivitiesData(data);
			console.log(data);
		} catch (error) {
			console.error("Error fetching activity data:", error);
		}
	};

	useEffect(() => {
		fetchActivity();
		fetchVitalLogs();
	}, [id]);

	// Vital log kaydetme fonksiyonu
	const saveVitalLog = async (changeType, previousValue, newValue) => {
		try {
			// Değerler zaten string ise tekrar stringify etme
			const prevValueStr =
				typeof previousValue === "string"
					? previousValue
					: JSON.stringify(previousValue);
			const newValueStr =
				typeof newValue === "string" ? newValue : JSON.stringify(newValue);

			const response = await fetch("https://app.vivasmartcare.com/api/vital-log-add", {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({
					deviceId: id,
					changeType,
					previousValue: prevValueStr,
					newValue: newValueStr,
					user: userInfo?.username || "unknown",
				}),
			});

			if (response.ok) {
				await fetchVitalLogs(); // Logları yeniden yükle
			}
		} catch (error) {
			console.error("Vital log kaydedilirken hata:", error);
		}
	};

	// Vital logları getirme fonksiyonu
	const fetchVitalLogs = async () => {
		try {
			const response = await fetch(`https://app.vivasmartcare.com/api/vital-logs/${id}`);
			if (response.ok) {
				const data = await response.json();
				setVitalLogs(data);
			}
		} catch (error) {
			console.error("Vital loglar alınırken hata:", error);
		}
	};

	// JSON verilerini okunaklı formata çeviren fonksiyon
	const formatVitalValue = (value, changeType) => {
		try {
			const parsed = typeof value === "string" ? JSON.parse(value) : value;

			switch (changeType) {
				case "fall":
					return (
						<div style={{ lineHeight: "1.8" }}>
							<div>
								<strong>Durum:</strong> {parsed.state ? "Aktif" : "Pasif"}
							</div>
							<div>
								<strong>Profil:</strong>{" "}
								{parsed.profile === "low"
									? "Düşük Risk"
									: parsed.profile === "high"
									? "Yüksek Risk"
									: parsed.profile}
							</div>
							{parsed.minimumTimeInBedSeconds !== undefined && (
								<div>
									<strong>Min. Yatakta Süre:</strong>{" "}
									{Math.round(parsed.minimumTimeInBedSeconds / 60)} dakika
								</div>
							)}
							{parsed.afterBedExitDelaySeconds !== undefined && (
								<div>
									<strong>Yataktan Çıkış Gecikmesi:</strong>{" "}
									{parsed.afterBedExitDelaySeconds} saniye
								</div>
							)}
							{parsed.always !== undefined && (
								<div>
									<strong>Her Zaman:</strong> {parsed.always ? "Evet" : "Hayır"}
								</div>
							)}
						</div>
					);

				case "hr":
					return (
						<div style={{ lineHeight: "1.8" }}>
							<div>
								<strong>Durum:</strong> {parsed.state ? "Aktif" : "Pasif"}
							</div>
							<div>
								<strong>Profil:</strong>{" "}
								{parsed.profile === "low"
									? "Düşük Seviye Risk"
									: parsed.profile === "medium"
									? "Orta Seviye Risk"
									: parsed.profile === "high"
									? "Yüksek Seviye Risk"
									: parsed.profile === "custom"
									? "Özel Uyarı"
									: parsed.profile}
							</div>
							{parsed.lowerBpm !== undefined && (
								<div>
									<strong>Alt Limit:</strong> {parsed.lowerBpm} bpm
								</div>
							)}
							{parsed.upperBpm !== undefined && (
								<div>
									<strong>Üst Limit:</strong> {parsed.upperBpm} bpm
								</div>
							)}
							{parsed.thresholds?.low?.[0]?.limit && (
								<div>
									<strong>Alt Eşik:</strong> {parsed.thresholds.low[0].limit}{" "}
									bpm
								</div>
							)}
							{parsed.thresholds?.high?.[0]?.limit && (
								<div>
									<strong>Üst Eşik:</strong> {parsed.thresholds.high[0].limit}{" "}
									bpm
								</div>
							)}
						</div>
					);

				case "rr":
					return (
						<div style={{ lineHeight: "1.8" }}>
							<div>
								<strong>Durum:</strong> {parsed.state ? "Aktif" : "Pasif"}
							</div>
							<div>
								<strong>Profil:</strong>{" "}
								{parsed.profile === "low"
									? "Düşük Seviye Risk"
									: parsed.profile === "medium"
									? "Orta Seviye Risk"
									: parsed.profile === "high"
									? "Yüksek Seviye Risk"
									: parsed.profile === "custom"
									? "Özel Uyarı"
									: parsed.profile}
							</div>
							{parsed.lower !== undefined && (
								<div>
									<strong>Alt Limit:</strong> {parsed.lower} rpm
								</div>
							)}
							{parsed.upper !== undefined && (
								<div>
									<strong>Üst Limit:</strong> {parsed.upper} rpm
								</div>
							)}
							{parsed.thresholds?.low?.[0]?.limit && (
								<div>
									<strong>Alt Eşik:</strong> {parsed.thresholds.low[0].limit}{" "}
									rpm
								</div>
							)}
							{parsed.thresholds?.high?.[0]?.limit && (
								<div>
									<strong>Üst Eşik:</strong> {parsed.thresholds.high[0].limit}{" "}
									rpm
								</div>
							)}
						</div>
					);

				case "pressureUlcers":
					return (
						<div style={{ lineHeight: "1.8" }}>
							<div>
								<strong>Durum:</strong> {parsed.state ? "Aktif" : "Pasif"}
							</div>
							<div>
								<strong>Profil:</strong>{" "}
								{parsed.profile === "2hrs"
									? "2 Saat"
									: parsed.profile === "3hrs"
									? "3 Saat"
									: parsed.profile}
							</div>
							{parsed.minimumTimeInBedSeconds !== undefined && (
								<div>
									<strong>Min. Yatakta Süre:</strong>{" "}
									{Math.round(parsed.minimumTimeInBedSeconds / 60)} dakika
								</div>
							)}
							{parsed.periodTimeInSeconds !== undefined && (
								<div>
									<strong>Periyot Süresi:</strong>{" "}
									{Math.round(parsed.periodTimeInSeconds / 60)} dakika
								</div>
							)}
							{parsed.onlyIfStatic !== undefined && (
								<div>
									<strong>Sadece Hareketsiz:</strong>{" "}
									{parsed.onlyIfStatic ? "Evet" : "Hayır"}
								</div>
							)}
						</div>
					);

				case "posture":
					return (
						<div style={{ lineHeight: "1.8" }}>
							<div>
								<strong>Yatakta:</strong>{" "}
								{parsed.inBed?.enabled ? "Aktif" : "Pasif"}
								{parsed.inBed?.onlyDuringSleepTime && " (Sadece uyku saatlerinde)"}
							</div>
							<div>
								<strong>Yataktan Çıkış:</strong>{" "}
								{parsed.outOfBed?.enabled ? "Aktif" : "Pasif"}
								{parsed.outOfBed?.onlyDuringSleepTime &&
									" (Sadece uyku saatlerinde)"}
							</div>
							<div>
								<strong>Yataktan Uzak:</strong>{" "}
								{parsed.awayFromBed?.enabled ? "Aktif" : "Pasif"}
								{parsed.awayFromBed?.onlyDuringSleepTime &&
									" (Sadece uyku saatlerinde)"}
								{parsed.awayFromBed?.delayMinutes && (
									<span> - {parsed.awayFromBed.delayMinutes} dakika</span>
								)}
							</div>
							{parsed.minimumTimeInBedMinutes !== undefined && (
								<div>
									<strong>Min. Yatakta Süre:</strong>{" "}
									{parsed.minimumTimeInBedMinutes} dakika
								</div>
							)}
						</div>
					);

				default:
					return (
						<pre
							style={{
								margin: 0,
								fontSize: "12px",
								whiteSpace: "pre-wrap",
								maxWidth: "300px",
								overflow: "auto",
							}}
						>
							{JSON.stringify(parsed, null, 2)}
						</pre>
					);
			}
		} catch (error) {
			// Parse edilemezse olduğu gibi göster
			const valueStr =
				typeof value === "string" ? value : JSON.stringify(value);
			return (
				<pre
					style={{
						margin: 0,
						fontSize: "12px",
						whiteSpace: "pre-wrap",
						maxWidth: "300px",
						overflow: "auto",
					}}
				>
					{valueStr}
				</pre>
			);
		}
	};

	/** Token alma */
	const authenticate = async () => {
		const response = await fetch(
			"https://eu.vitalerter.com/api/v1/organizations/apiaccess/authenticate",
			{
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization:
						"Bearer /9m2n37CxCoGq9wVW1Sm1+tMsZHhPgPoay2eESkrPpY28apaCXhP1yCQY9fhks4H",
				},
				body: JSON.stringify({
					apiKey:
						"/9m2n37CxCoGq9wVW1Sm1+tMsZHhPgPoay2eESkrPpY28apaCXhP1yCQY9fhks4H",
				}),
			}
		);

		if (!response.ok) {
			throw new Error(`Auth error: ${response.status}`);
		}

		const data = await response.json();
		// Token alan adı ne olursa olsun yakala
		const tk =
			data?.token || data?.accessToken || data?.access_token || data?.jwt || "";
		return tk || data;
	};

	/** 🧑 Resident ID çekme */
	const fetchResidentId = async (token) => {
		const response = await fetch(
			`https://eu.vitalerter.com/api/v1/devices/${id}`,
			{
				method: "GET",
				headers: {
					Authorization: `Bearer ${token}`,
				},
			}
		);

		if (!response.ok) {
			throw new Error(`Device fetch error: ${response.status}`);
		}

		const data = await response.json();
		const rId = data?.resident?.id;
		setResidentId(rId);
		console.log("Resident ID:", rId);
		return rId;
	};

	/** Fall datası çekme */
	const fetchFall = async (token, rId) => {
		try {
			const response = await fetch(
				`https://eu.vitalerter.com/api/v1/residents/${rId}/rules/preventions/fall`,
				{
					method: "GET",
					headers: {
						Authorization: `Bearer ${token}`,
					},
				}
			);

			if (!response.ok) {
				throw new Error(`Fall fetch error: ${response.status}`);
			}

			const data = await response.json();
			setFallStatus(data);
			console.log("Fall data:", data);
		} catch (err) {
			console.error("fetchFall error:", err);
		}
	};

	/** Fall ayarlarını PUT ile güncelle */
	const updateFallSettings = async () => {
		if (!residentId || !vToken) {
			alert("Gerekli bilgiler eksik.");
			return;
		}

		// Önceki değeri sakla (fallStatus varsa onu kullan, yoksa fallConfig'i kullan)
		const previousValue = fallStatus
			? {
					state: fallStatus.state,
					profile: fallStatus.profile,
					minimumTimeInBedSeconds: fallStatus.minimumTimeInBedSeconds,
					afterBedExitDelaySeconds: fallStatus.afterBedExitDelaySeconds,
					always: fallStatus.always,
			  }
			: { ...fallConfig };

		try {
			const response = await fetch(
				`https://eu.vitalerter.com/api/v1/residents/${residentId}/rules/preventions/fall`,
				{
					method: "PUT",
					headers: {
						"Content-Type": "application/json",
						Authorization: `Bearer ${vToken}`,
					},
					body: JSON.stringify({
						state: fallConfig.state,
						profile:
							typeof fallConfig.profile === "string"
								? fallConfig.profile.charAt(0).toUpperCase() +
								  fallConfig.profile.slice(1).toLowerCase()
								: fallConfig.profile,
						minimumTimeInBedSeconds: fallConfig.minimumTimeInBedSeconds,
						afterBedExitDelaySeconds: fallConfig.afterBedExitDelaySeconds,
						always: fallConfig.always,
					}),
				}
			);

			if (!response.ok) {
				const errorData = await response.json();
				throw new Error(
					errorData?.message || `Fall update error: ${response.status}`
				);
			}

			const updatedData = await response.json();
			setFallStatus(updatedData);

			// Log kaydet
			await saveVitalLog("fall", previousValue, fallConfig);

			alert("Düşme bildirimi başarıyla güncellendi!");
			setFallModal(false);
			window.location.reload();
		} catch (error) {
			console.error("Fall ayarları güncellenirken hata oluştu:", error);
			alert(error.message || "Bilinmeyen bir hata oluştu.");
		}
	};

	// --- STATE EKLEMESİ ---
	const [pressureUlcersModal, setPressureUlcersModal] = useState(false);

	const [pressureUlcersConfig, setPressureUlcersConfig] = useState({
		state: false,
		profile: "default",
		minimumTimeInBedSeconds: 0,
		periodTimeInSeconds: 0,
		onlyIfStatic: true,
		periods: [],
	});

	// --- GET: Duruş değişikliği verilerini çek ---
	const fetchPressureUlcers = async (token, rId) => {
		try {
			const response = await fetch(
				`https://eu.vitalerter.com/api/v1/residents/${rId}/rules/protocols/pressureUlcers`,
				{
					method: "GET",
					headers: { Authorization: `Bearer ${token}` },
				}
			);

			if (!response.ok) throw new Error(`Fetch error: ${response.status}`);
			const data = await response.json();

			setPressureUlcersConfig({
				state: data?.state ?? false,
				profile: data?.profile ?? "default",
				minimumTimeInBedSeconds: data?.minimumTimeInBedSeconds ?? 0,
				periodTimeInSeconds: data?.periodTimeInSeconds ?? 0,
				onlyIfStatic: data?.onlyIfStatic ?? true,
				periods: data?.periods ?? [],
			});
		} catch (err) {
			console.error("fetchPressureUlcers error:", err);
		}
	};

	// --- PUT: Duruş değişikliği ayarlarını güncelle ---
	const updatePressureUlcersSettings = async () => {
		if (!residentId || !vToken) {
			alert("Eksik bilgi!");
			return;
		}

		// Önceki değeri sakla
		const previousValue = { ...pressureUlcersConfig };

		try {
			const response = await fetch(
				`https://eu.vitalerter.com/api/v1/residents/${residentId}/rules/protocols/pressureUlcers`,
				{
					method: "PUT",
					headers: {
						"Content-Type": "application/json",
						Authorization: `Bearer ${vToken}`,
					},
					body: JSON.stringify(pressureUlcersConfig),
				}
			);

			if (!response.ok) {
				const errorData = await response.json();
				throw new Error(errorData?.message || "Güncelleme hatası");
			}

			// Log kaydet
			await saveVitalLog("pressureUlcers", previousValue, pressureUlcersConfig);

			alert("Duruş değişikliği başarıyla güncellendi!");
			setPressureUlcersModal(false);
			window.location.reload();
		} catch (err) {
			console.error("updatePressureUlcersSettings error:", err);
			alert(err.message);
		}
	};

	// --- GET: HR thresholds (NEW) ---
	const fetchHrThresholds = async (token, rId) => {
		try {
			const response = await fetch(
				`https://eu.vitalerter.com/api/v1/residents/${rId}/rules/thresholds/hr`,
				{ method: "GET", headers: { Authorization: `Bearer ${token}` } }
			);
			if (!response.ok) throw new Error(`HR fetch error: ${response.status}`);
			const data = await response.json();

			const isCustom = String(data?.profile || "").toLowerCase() === "custom";
			const lowerFromApi =
				(isCustom && data?.thresholds?.low?.[0]?.limit) ??
				data?.lowerBpm ??
				data?.lower ??
				data?.lowerThresholdBpm ??
				55;

			const upperFromApi =
				(isCustom && data?.thresholds?.high?.[0]?.limit) ??
				data?.upperBpm ??
				data?.upper ??
				data?.upperThresholdBpm ??
				110;

			let profile =
				(data?.profile && String(data.profile).toLowerCase()) || "custom";
			if (!data?.profile) {
				const same = (p) =>
					p.lowerBpm === Number(lowerFromApi) &&
					p.upperBpm === Number(upperFromApi);
				if (same(HR_PRESETS.low)) profile = "low";
				else if (same(HR_PRESETS.medium)) profile = "medium";
				else if (same(HR_PRESETS.high)) profile = "high";
				else profile = "custom";
			}

			setHrConfig({
				state: data?.state ?? false,
				profile,
				lowerBpm: Number(lowerFromApi),
				upperBpm: Number(upperFromApi),
				thresholds: {
					low: data?.thresholds?.low?.length
						? data.thresholds.low
						: [
								{
									limit: Number(lowerFromApi),
									minimumDurationSeconds: 15,
									type: null,
								},
						  ],
					high: data?.thresholds?.high?.length
						? data.thresholds.high
						: [
								{
									limit: Number(upperFromApi),
									minimumDurationSeconds: 15,
									type: null,
								},
						  ],
				},
				periods: data?.periods ?? [],
				measurement: data?.measurement ?? false,
				measurementFrequency: data?.measurementFrequency ?? null,
				id: data?.id ?? "hr",
			});
		} catch (err) {
			console.error("fetchHrThresholds error:", err);
		}
	};

	// --- PUT: HR thresholds (NEW) ---
	const updateHrThresholds = async () => {
		if (!residentId || !vToken) {
			alert("Eksik bilgi!");
			return;
		}

		// Önceki değeri sakla
		const previousValue = { ...hrConfig };

		try {
			let body;

			if (hrConfig.profile === "custom") {
				const lowObj = hrConfig.thresholds.low?.[0] || {
					minimumDurationSeconds: 15,
					type: null,
				};
				const highObj = hrConfig.thresholds.high?.[0] || {
					minimumDurationSeconds: 15,
					type: null,
				};

				body = {
					state: hrConfig.state,
					profile: "custom",
					thresholds: {
						low: [{ ...lowObj, limit: Number(hrConfig.lowerBpm) }],
						high: [{ ...highObj, limit: Number(hrConfig.upperBpm) }],
					},
					periods: hrConfig.periods || [],
					measurement: !!hrConfig.measurement,
					measurementFrequency: hrConfig.measurementFrequency,
					id: hrConfig.id || "hr",
				};
			} else {
				const p = HR_PRESETS[hrConfig.profile] || HR_PRESETS.high;
				const lowObj = hrConfig.thresholds.low?.[0] || {
					minimumDurationSeconds: 15,
					type: null,
				};
				const highObj = hrConfig.thresholds.high?.[0] || {
					minimumDurationSeconds: 15,
					type: null,
				};

				body = {
					state: hrConfig.state,
					profile: hrConfig.profile,
					thresholds: {
						low: [{ ...lowObj, limit: p.lowerBpm }],
						high: [{ ...highObj, limit: p.upperBpm }],
					},
					periods: hrConfig.periods || [],
					measurement: !!hrConfig.measurement,
					measurementFrequency: hrConfig.measurementFrequency,
					id: hrConfig.id || "hr",
				};
			}

			const response = await fetch(
				`https://eu.vitalerter.com/api/v1/residents/${residentId}/rules/thresholds/hr`,
				{
					method: "PUT",
					headers: {
						"Content-Type": "application/json",
						Authorization: `Bearer ${vToken}`,
					},
					body: JSON.stringify(body),
				}
			);

			if (!response.ok) {
				const errorData = await response.json();
				throw new Error(errorData?.message || "HR güncelleme hatası");
			}

			// Log kaydet
			await saveVitalLog("hr", previousValue, hrConfig);

			alert("Kalp atış hızı eşiği başarıyla güncellendi!");
			setHrModal(false);
			window.location.reload();
		} catch (err) {
			console.error("updateHrThresholds error:", err);
			alert(err.message);
		}
	};

	// --- GET: RR thresholds (NEW) ---
	const fetchRrThresholds = async (token, rId) => {
		try {
			const res = await fetch(
				`https://eu.vitalerter.com/api/v1/residents/${rId}/rules/thresholds/rr`,
				{ method: "GET", headers: { Authorization: `Bearer ${token}` } }
			);
			if (!res.ok) throw new Error(`RR fetch error: ${res.status}`);
			const data = await res.json();

			const isCustom = String(data?.profile || "").toLowerCase() === "custom";
			const lowerFromApi =
				(isCustom && data?.thresholds?.low?.[0]?.limit) ??
				data?.lowerRpm ??
				data?.lower ??
				data?.lowerThresholdRpm ??
				RR_PRESETS.high.lower;
			const upperFromApi =
				(isCustom && data?.thresholds?.high?.[0]?.limit) ??
				data?.upperRpm ??
				data?.upper ??
				data?.upperThresholdRpm ??
				RR_PRESETS.high.upper;

			let profile =
				(data?.profile && String(data.profile).toLowerCase()) || "custom";
			if (!data?.profile) {
				const same = (p) =>
					p.lower === Number(lowerFromApi) && p.upper === Number(upperFromApi);
				if (same(RR_PRESETS.low)) profile = "low";
				else if (same(RR_PRESETS.medium)) profile = "medium";
				else if (same(RR_PRESETS.high)) profile = "high";
				else profile = "custom";
			}

			setRrConfig({
				state: data?.state ?? false,
				profile,
				lower: Math.max(RR_MIN, Number(lowerFromApi)),
				upper: Math.min(RR_MAX, Number(upperFromApi)),
				thresholds: {
					low: data?.thresholds?.low?.length
						? data.thresholds.low
						: [
								{
									limit: Number(lowerFromApi),
									minimumDurationSeconds: 15,
									type: null,
								},
						  ],
					high: data?.thresholds?.high?.length
						? data.thresholds.high
						: [
								{
									limit: Number(upperFromApi),
									minimumDurationSeconds: 15,
									type: null,
								},
						  ],
				},
				periods: data?.periods ?? [],
				measurement: data?.measurement ?? false,
				measurementFrequency: data?.measurementFrequency ?? null,
				id: data?.id ?? "rr",
			});
		} catch (err) {
			console.error("fetchRrThresholds error:", err);
		}
	};

	// --- PUT: RR thresholds (NEW) ---
	const updateRrThresholds = async () => {
		if (!residentId || !vToken) {
			alert("Eksik bilgi!");
			return;
		}

		// Önceki değeri sakla
		const previousValue = { ...rrConfig };

		try {
			let body;

			if (rrConfig.profile === "custom") {
				const lowObj = rrConfig.thresholds.low?.[0] || {
					minimumDurationSeconds: 15,
					type: null,
				};
				const highObj = rrConfig.thresholds.high?.[0] || {
					minimumDurationSeconds: 15,
					type: null,
				};

				body = {
					state: rrConfig.state,
					profile: "custom",
					thresholds: {
						low: [{ ...lowObj, limit: Number(rrConfig.lower) }],
						high: [{ ...highObj, limit: Number(rrConfig.upper) }],
					},
					periods: rrConfig.periods || [],
					measurement: !!rrConfig.measurement,
					measurementFrequency: rrConfig.measurementFrequency,
					id: rrConfig.id || "rr",
				};
			} else {
				const p = RR_PRESETS[rrConfig.profile] || RR_PRESETS.high;
				const lowObj = rrConfig.thresholds.low?.[0] || {
					minimumDurationSeconds: 15,
					type: null,
				};
				const highObj = rrConfig.thresholds.high?.[0] || {
					minimumDurationSeconds: 15,
					type: null,
				};

				body = {
					state: rrConfig.state,
					profile: rrConfig.profile,
					thresholds: {
						low: [{ ...lowObj, limit: p.lower }],
						high: [{ ...highObj, limit: p.upper }],
					},
					periods: rrConfig.periods || [],
					measurement: !!rrConfig.measurement,
					measurementFrequency: rrConfig.measurementFrequency,
					id: rrConfig.id || "rr",
				};
			}

			const response = await fetch(
				`https://eu.vitalerter.com/api/v1/residents/${residentId}/rules/thresholds/rr`,
				{
					method: "PUT",
					headers: {
						"Content-Type": "application/json",
						Authorization: `Bearer ${vToken}`,
					},
					body: JSON.stringify(body),
				}
			);

			if (!response.ok) {
				const errorData = await response.json();
				throw new Error(errorData?.message || "RR güncelleme hatası");
			}

			// Log kaydet
			await saveVitalLog("rr", previousValue, rrConfig);

			alert("Solunum hızı eşiği başarıyla güncellendi!");
			setRrModal(false);
			window.location.reload();
		} catch (err) {
			console.error("updateRrThresholds error:", err);
			alert(err.message);
		}
	};

	// --- GET: Bed Occupancy (Yatak Doluluk) verilerini çek ---
	const fetchPosture = async (token, rId) => {
		try {
			const response = await fetch(
				`https://eu.vitalerter.com/api/v1/residents/${rId}/rules/bedOccupancy`,
				{
					method: "GET",
					headers: { Authorization: `Bearer ${token}` },
				}
			);

			if (!response.ok) {
				// 404 ise varsayılan değerleri kullan
				if (response.status === 404) {
					console.log("Bed Occupancy ayarları bulunamadı, varsayılan değerler kullanılıyor");
					setPostureStatus(null);
					return;
				}
				throw new Error(`Bed Occupancy fetch error: ${response.status}`);
			}

			const data = await response.json();
			console.log("Bed Occupancy API Response:", JSON.stringify(data, null, 2));

			// Ham veriyi sakla
			setPostureStatus(data);

			// API'den gelen veriyi state'e uygun formata çevir
			// API'nin gerçek formatını kontrol et ve ona göre parse et
			// Farklı formatlar: inBed, in_bed, inBedEnabled, inBed.enabled vb.
			
			// In Bed kontrolü
			let inBedEnabled = false;
			let inBedOnlySleep = false;
			if (data?.inBed) {
				if (typeof data.inBed === 'object') {
					inBedEnabled = data.inBed.enabled ?? data.inBed.state ?? false;
					inBedOnlySleep = data.inBed.onlyDuringSleepTime ?? data.inBed.onlyDuringSleep ?? false;
				} else if (typeof data.inBed === 'boolean') {
					inBedEnabled = data.inBed;
				}
			} else if (data?.in_bed) {
				if (typeof data.in_bed === 'object') {
					inBedEnabled = data.in_bed.enabled ?? data.in_bed.state ?? false;
					inBedOnlySleep = data.in_bed.onlyDuringSleepTime ?? data.in_bed.only_during_sleep_time ?? false;
				} else if (typeof data.in_bed === 'boolean') {
					inBedEnabled = data.in_bed;
				}
			} else {
				inBedEnabled = data?.inBedEnabled ?? data?.in_bed_enabled ?? false;
				inBedOnlySleep = data?.inBedOnlyDuringSleepTime ?? data?.in_bed_only_during_sleep_time ?? false;
			}

			// Out of Bed kontrolü
			let outOfBedEnabled = false;
			let outOfBedOnlySleep = false;
			if (data?.outOfBed) {
				if (typeof data.outOfBed === 'object') {
					outOfBedEnabled = data.outOfBed.enabled ?? data.outOfBed.state ?? false;
					outOfBedOnlySleep = data.outOfBed.onlyDuringSleepTime ?? data.outOfBed.onlyDuringSleep ?? false;
				} else if (typeof data.outOfBed === 'boolean') {
					outOfBedEnabled = data.outOfBed;
				}
			} else if (data?.out_of_bed) {
				if (typeof data.out_of_bed === 'object') {
					outOfBedEnabled = data.out_of_bed.enabled ?? data.out_of_bed.state ?? false;
					outOfBedOnlySleep = data.out_of_bed.onlyDuringSleepTime ?? data.out_of_bed.only_during_sleep_time ?? false;
				} else if (typeof data.out_of_bed === 'boolean') {
					outOfBedEnabled = data.out_of_bed;
				}
			} else {
				outOfBedEnabled = data?.outOfBedEnabled ?? data?.out_of_bed_enabled ?? false;
				outOfBedOnlySleep = data?.outOfBedOnlyDuringSleepTime ?? data?.out_of_bed_only_during_sleep_time ?? false;
			}

			// Away from Bed kontrolü
			let awayFromBedEnabled = false;
			let awayFromBedOnlySleep = false;
			let delayMinutes = 1;
			if (data?.awayFromBed) {
				if (typeof data.awayFromBed === 'object') {
					awayFromBedEnabled = data.awayFromBed.enabled ?? data.awayFromBed.state ?? false;
					awayFromBedOnlySleep = data.awayFromBed.onlyDuringSleepTime ?? data.awayFromBed.onlyDuringSleep ?? false;
					delayMinutes = data.awayFromBed.delayMinutes ?? data.awayFromBed.delay_minutes ?? data.awayFromBed.delay ?? 1;
				} else if (typeof data.awayFromBed === 'boolean') {
					awayFromBedEnabled = data.awayFromBed;
				}
			} else if (data?.away_from_bed) {
				if (typeof data.away_from_bed === 'object') {
					awayFromBedEnabled = data.away_from_bed.enabled ?? data.away_from_bed.state ?? false;
					awayFromBedOnlySleep = data.away_from_bed.onlyDuringSleepTime ?? data.away_from_bed.only_during_sleep_time ?? false;
					delayMinutes = data.away_from_bed.delayMinutes ?? data.away_from_bed.delay_minutes ?? data.away_from_bed.delay ?? 1;
				} else if (typeof data.away_from_bed === 'boolean') {
					awayFromBedEnabled = data.away_from_bed;
				}
			} else {
				awayFromBedEnabled = data?.awayFromBedEnabled ?? data?.away_from_bed_enabled ?? false;
				awayFromBedOnlySleep = data?.awayFromBedOnlyDuringSleepTime ?? data?.away_from_bed_only_during_sleep_time ?? false;
				delayMinutes = data?.awayFromBedDelayMinutes ?? data?.away_from_bed_delay_minutes ?? data?.delayMinutes ?? 1;
			}

			// Minimum time in bed
			const minTimeInBed = 
				data?.minimumTimeInBedMinutes ?? 
				data?.minimum_time_in_bed_minutes ??
				data?.minimumTimeInBed ??
				data?.minimum_time_in_bed ??
				1;

			setPostureConfig({
				inBed: {
					enabled: inBedEnabled,
					onlyDuringSleepTime: inBedOnlySleep,
				},
				outOfBed: {
					enabled: outOfBedEnabled,
					onlyDuringSleepTime: outOfBedOnlySleep,
				},
				awayFromBed: {
					enabled: awayFromBedEnabled,
					onlyDuringSleepTime: awayFromBedOnlySleep,
					delayMinutes: delayMinutes,
				},
				minimumTimeInBedMinutes: minTimeInBed,
				sleepTime: {
					periods: data?.sleepTime?.periods ?? 
					         data?.sleep_time?.periods ?? 
					         [
					         	{ start: "19:30", end: "07:30" },
					         	{ start: "13:30", end: "16:30" },
					         ],
				},
			});
		} catch (err) {
			console.error("fetchPosture error:", err);
		}
	};

	// --- PUT: Bed Occupancy (Yatak Doluluk) ayarlarını güncelle ---
	const updatePostureSettings = async () => {
		if (!residentId || !vToken) {
			alert("Eksik bilgi!");
			return;
		}

		// Önceki değeri sakla
		const previousValue = { ...postureConfig };

		try {
			// API'den gelen formatı tam olarak kullan
			// API muhtemelen flat format bekliyor veya kendi formatını bekliyor
			let body;
			
			if (postureStatus) {
				// API'den gelen formatı olduğu gibi kullan, sadece değerleri güncelle
				body = JSON.parse(JSON.stringify(postureStatus));
				
				// API formatına göre değerleri güncelle
				// Eğer API flat format bekliyorsa (inBedEnabled, inBedOnlyDuringSleepTime vb.)
				if (body.hasOwnProperty('inBedEnabled') || body.hasOwnProperty('in_bed_enabled')) {
					// Flat format
					body.inBedEnabled = body.inBedEnabled ?? body.in_bed_enabled ?? postureConfig.inBed.enabled;
					body.inBedOnlyDuringSleepTime = body.inBedOnlyDuringSleepTime ?? body.in_bed_only_during_sleep_time ?? postureConfig.inBed.onlyDuringSleepTime;
					body.outOfBedEnabled = body.outOfBedEnabled ?? body.out_of_bed_enabled ?? postureConfig.outOfBed.enabled;
					body.outOfBedOnlyDuringSleepTime = body.outOfBedOnlyDuringSleepTime ?? body.out_of_bed_only_during_sleep_time ?? postureConfig.outOfBed.onlyDuringSleepTime;
					body.awayFromBedEnabled = body.awayFromBedEnabled ?? body.away_from_bed_enabled ?? postureConfig.awayFromBed.enabled;
					body.awayFromBedOnlyDuringSleepTime = body.awayFromBedOnlyDuringSleepTime ?? body.away_from_bed_only_during_sleep_time ?? postureConfig.awayFromBed.onlyDuringSleepTime;
					body.awayFromBedDelayMinutes = body.awayFromBedDelayMinutes ?? body.away_from_bed_delay_minutes ?? postureConfig.awayFromBed.delayMinutes;
				} else if (body.inBed && typeof body.inBed === 'object') {
					// Nested object format - API bunu kabul etmiyor, flat format'a çevir
					// Ama önce API'den gelen formatı kontrol et
					body.inBedEnabled = postureConfig.inBed.enabled;
					body.inBedOnlyDuringSleepTime = postureConfig.inBed.onlyDuringSleepTime;
					body.outOfBedEnabled = postureConfig.outOfBed.enabled;
					body.outOfBedOnlyDuringSleepTime = postureConfig.outOfBed.onlyDuringSleepTime;
					body.awayFromBedEnabled = postureConfig.awayFromBed.enabled;
					body.awayFromBedOnlyDuringSleepTime = postureConfig.awayFromBed.onlyDuringSleepTime;
					body.awayFromBedDelayMinutes = postureConfig.awayFromBed.delayMinutes;
					// Eski nested field'ları kaldır
					delete body.inBed;
					delete body.outOfBed;
					delete body.awayFromBed;
				} else {
					// Bilinmeyen format - API'den gelen formatı koru ve değerleri güncelle
					// Ama nested object'leri flat format'a çevir
					body.inBedEnabled = postureConfig.inBed.enabled;
					body.inBedOnlyDuringSleepTime = postureConfig.inBed.onlyDuringSleepTime;
					body.outOfBedEnabled = postureConfig.outOfBed.enabled;
					body.outOfBedOnlyDuringSleepTime = postureConfig.outOfBed.onlyDuringSleepTime;
					body.awayFromBedEnabled = postureConfig.awayFromBed.enabled;
					body.awayFromBedOnlyDuringSleepTime = postureConfig.awayFromBed.onlyDuringSleepTime;
					body.awayFromBedDelayMinutes = postureConfig.awayFromBed.delayMinutes;
					// Nested field'ları kaldır
					delete body.inBed;
					delete body.outOfBed;
					delete body.awayFromBed;
				}
				
				body.minimumTimeInBedMinutes = postureConfig.minimumTimeInBedMinutes;
				body.sleepTime = postureConfig.sleepTime;
			} else {
				// İlk kez oluşturuluyorsa, flat format kullan
				body = {
					inBedEnabled: postureConfig.inBed.enabled,
					inBedOnlyDuringSleepTime: postureConfig.inBed.onlyDuringSleepTime,
					outOfBedEnabled: postureConfig.outOfBed.enabled,
					outOfBedOnlyDuringSleepTime: postureConfig.outOfBed.onlyDuringSleepTime,
					awayFromBedEnabled: postureConfig.awayFromBed.enabled,
					awayFromBedOnlyDuringSleepTime: postureConfig.awayFromBed.onlyDuringSleepTime,
					awayFromBedDelayMinutes: postureConfig.awayFromBed.delayMinutes,
					minimumTimeInBedMinutes: postureConfig.minimumTimeInBedMinutes,
					sleepTime: postureConfig.sleepTime,
				};
			}

			console.log("Bed Occupancy PUT Request Body:", JSON.stringify(body, null, 2));
			console.log("Original postureStatus:", JSON.stringify(postureStatus, null, 2));

			const response = await fetch(
				`https://eu.vitalerter.com/api/v1/residents/${residentId}/rules/bedOccupancy`,
				{
					method: "PUT",
					headers: {
						"Content-Type": "application/json",
						Authorization: `Bearer ${vToken}`,
					},
					body: JSON.stringify(body),
				}
			);

			if (!response.ok) {
				const errorData = await response.json();
				console.error("Bed Occupancy PUT Error - Full Response:", JSON.stringify(errorData, null, 2));
				
				// Validation hatalarını daha detaylı göster
				let errorMessage = "Bed Occupancy güncelleme hatası";
				if (errorData?.errors) {
					const errorDetails = Object.entries(errorData.errors)
						.map(([key, value]) => `${key}: ${Array.isArray(value) ? value.join(", ") : value}`)
						.join("\n");
					errorMessage = `Validation hatası:\n${errorDetails}`;
				} else if (errorData?.message) {
					errorMessage = errorData.message;
				} else if (errorData?.title) {
					errorMessage = errorData.title;
				}
				
				throw new Error(errorMessage);
			}

			const updatedData = await response.json();
			console.log("Bed Occupancy PUT Response:", JSON.stringify(updatedData, null, 2));

			// Log kaydet
			await saveVitalLog("posture", previousValue, postureConfig);
			
			// Logları yeniden yükle (saveVitalLog içinde zaten yapılıyor ama emin olmak için)
			await fetchVitalLogs();

			// Başarı mesajını ayarla ve popup göster
			setSuccessMessage("Yatak doluluk ayarları başarıyla güncellendi!");
			setSuccessModal(true);
			
			// Modal'ı kapat
			setPostureModal(false);
		} catch (err) {
			console.error("updatePostureSettings error:", err);
			alert(err.message);
		}
	};

	/** useEffect zinciri: token -> residentId -> fall/pressure/hr/rr/posture çek */
	useEffect(() => {
		const run = async () => {
			try {
				const token = await authenticate();
				setVToken(token);
				const rId = await fetchResidentId(token);
				if (rId) {
					await fetchFall(token, rId);
					await fetchPressureUlcers(token, rId);
					await fetchHrThresholds(token, rId);
					await fetchRrThresholds(token, rId);
					await fetchPosture(token, rId);
				} else {
					console.warn("Resident ID bulunamadı.");
				}
			} catch (error) {
				console.error("Hata oluştu:", error);
			}
		};

		run();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [id]);

	/** Eğer modal açıldığında mevcut fallStatus varsa fallConfig'e yükle (modal açıldığında gösterilsin) */
	useEffect(() => {
		if (fallModal && fallStatus) {
			setFallConfig({
				state: fallStatus?.state ?? false,
				profile: fallStatus?.profile ? fallStatus.profile.toLowerCase() : "low",
				minimumTimeInBedSeconds: fallStatus?.minimumTimeInBedSeconds ?? 0,
				afterBedExitDelaySeconds: fallStatus?.afterBedExitDelaySeconds ?? 0,
				always: fallStatus?.always ?? false,
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [fallModal, fallStatus]);

	/** Eğer modal açıldığında mevcut postureStatus varsa postureConfig'e yükle (modal açıldığında gösterilsin) */
	useEffect(() => {
		if (postureModal && postureStatus) {
			// API'den gelen veriyi state'e uygun formata çevir (fetchPosture ile aynı mantık)
			// In Bed kontrolü
			let inBedEnabled = false;
			let inBedOnlySleep = false;
			if (postureStatus?.inBed) {
				if (typeof postureStatus.inBed === 'object') {
					inBedEnabled = postureStatus.inBed.enabled ?? postureStatus.inBed.state ?? false;
					inBedOnlySleep = postureStatus.inBed.onlyDuringSleepTime ?? postureStatus.inBed.onlyDuringSleep ?? false;
				} else if (typeof postureStatus.inBed === 'boolean') {
					inBedEnabled = postureStatus.inBed;
				}
			} else if (postureStatus?.in_bed) {
				if (typeof postureStatus.in_bed === 'object') {
					inBedEnabled = postureStatus.in_bed.enabled ?? postureStatus.in_bed.state ?? false;
					inBedOnlySleep = postureStatus.in_bed.onlyDuringSleepTime ?? postureStatus.in_bed.only_during_sleep_time ?? false;
				} else if (typeof postureStatus.in_bed === 'boolean') {
					inBedEnabled = postureStatus.in_bed;
				}
			} else {
				inBedEnabled = postureStatus?.inBedEnabled ?? postureStatus?.in_bed_enabled ?? false;
				inBedOnlySleep = postureStatus?.inBedOnlyDuringSleepTime ?? postureStatus?.in_bed_only_during_sleep_time ?? false;
			}

			// Out of Bed kontrolü
			let outOfBedEnabled = false;
			let outOfBedOnlySleep = false;
			if (postureStatus?.outOfBed) {
				if (typeof postureStatus.outOfBed === 'object') {
					outOfBedEnabled = postureStatus.outOfBed.enabled ?? postureStatus.outOfBed.state ?? false;
					outOfBedOnlySleep = postureStatus.outOfBed.onlyDuringSleepTime ?? postureStatus.outOfBed.onlyDuringSleep ?? false;
				} else if (typeof postureStatus.outOfBed === 'boolean') {
					outOfBedEnabled = postureStatus.outOfBed;
				}
			} else if (postureStatus?.out_of_bed) {
				if (typeof postureStatus.out_of_bed === 'object') {
					outOfBedEnabled = postureStatus.out_of_bed.enabled ?? postureStatus.out_of_bed.state ?? false;
					outOfBedOnlySleep = postureStatus.out_of_bed.onlyDuringSleepTime ?? postureStatus.out_of_bed.only_during_sleep_time ?? false;
				} else if (typeof postureStatus.out_of_bed === 'boolean') {
					outOfBedEnabled = postureStatus.out_of_bed;
				}
			} else {
				outOfBedEnabled = postureStatus?.outOfBedEnabled ?? postureStatus?.out_of_bed_enabled ?? false;
				outOfBedOnlySleep = postureStatus?.outOfBedOnlyDuringSleepTime ?? postureStatus?.out_of_bed_only_during_sleep_time ?? false;
			}

			// Away from Bed kontrolü
			let awayFromBedEnabled = false;
			let awayFromBedOnlySleep = false;
			let delayMinutes = 1;
			if (postureStatus?.awayFromBed) {
				if (typeof postureStatus.awayFromBed === 'object') {
					awayFromBedEnabled = postureStatus.awayFromBed.enabled ?? postureStatus.awayFromBed.state ?? false;
					awayFromBedOnlySleep = postureStatus.awayFromBed.onlyDuringSleepTime ?? postureStatus.awayFromBed.onlyDuringSleep ?? false;
					delayMinutes = postureStatus.awayFromBed.delayMinutes ?? postureStatus.awayFromBed.delay_minutes ?? postureStatus.awayFromBed.delay ?? 1;
				} else if (typeof postureStatus.awayFromBed === 'boolean') {
					awayFromBedEnabled = postureStatus.awayFromBed;
				}
			} else if (postureStatus?.away_from_bed) {
				if (typeof postureStatus.away_from_bed === 'object') {
					awayFromBedEnabled = postureStatus.away_from_bed.enabled ?? postureStatus.away_from_bed.state ?? false;
					awayFromBedOnlySleep = postureStatus.away_from_bed.onlyDuringSleepTime ?? postureStatus.away_from_bed.only_during_sleep_time ?? false;
					delayMinutes = postureStatus.away_from_bed.delayMinutes ?? postureStatus.away_from_bed.delay_minutes ?? postureStatus.away_from_bed.delay ?? 1;
				} else if (typeof postureStatus.away_from_bed === 'boolean') {
					awayFromBedEnabled = postureStatus.away_from_bed;
				}
			} else {
				awayFromBedEnabled = postureStatus?.awayFromBedEnabled ?? postureStatus?.away_from_bed_enabled ?? false;
				awayFromBedOnlySleep = postureStatus?.awayFromBedOnlyDuringSleepTime ?? postureStatus?.away_from_bed_only_during_sleep_time ?? false;
				delayMinutes = postureStatus?.awayFromBedDelayMinutes ?? postureStatus?.away_from_bed_delay_minutes ?? postureStatus?.delayMinutes ?? 1;
			}

			// Minimum time in bed
			const minTimeInBed = 
				postureStatus?.minimumTimeInBedMinutes ?? 
				postureStatus?.minimum_time_in_bed_minutes ??
				postureStatus?.minimumTimeInBed ??
				postureStatus?.minimum_time_in_bed ??
				1;

			setPostureConfig({
				inBed: {
					enabled: inBedEnabled,
					onlyDuringSleepTime: inBedOnlySleep,
				},
				outOfBed: {
					enabled: outOfBedEnabled,
					onlyDuringSleepTime: outOfBedOnlySleep,
				},
				awayFromBed: {
					enabled: awayFromBedEnabled,
					onlyDuringSleepTime: awayFromBedOnlySleep,
					delayMinutes: delayMinutes,
				},
				minimumTimeInBedMinutes: minTimeInBed,
				sleepTime: {
					periods: postureStatus?.sleepTime?.periods ?? 
					         postureStatus?.sleep_time?.periods ?? 
					         [
					         	{ start: "19:30", end: "07:30" },
					         	{ start: "13:30", end: "16:30" },
					         ],
				},
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [postureModal, postureStatus]);

	// --- HR profile seçildiğinde preset eşikleri uygula (Custom hariç) ---
	useEffect(() => {
		if (hrConfig.profile !== "custom") {
			const p = HR_PRESETS[hrConfig.profile] || HR_PRESETS.high;
			setHrConfig((prev) => ({
				...prev,
				lowerBpm: p.lowerBpm,
				upperBpm: p.upperBpm,
			}));
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [hrConfig.profile]);

	// --- RR profile seçildiğinde preset eşikleri uygula (Custom hariç) ---
	useEffect(() => {
		if (rrConfig.profile !== "custom") {
			const p = RR_PRESETS[rrConfig.profile] || RR_PRESETS.high;
			setRrConfig((prev) => ({
				...prev,
				lower: p.lower,
				upper: p.upper,
			}));
		}
	}, [rrConfig.profile]);

	return (
		<>
			<Breadcrumb showPath={"show"} id={deviceDetail} />
			<div
				className={`device-wrapper component-wrapper ${
					sidebarOpen ? "" : "close"
				}`}
			>
				{/* Cihaz Oda ve Süit Bilgisi */}
				{deviceDetail && (deviceDetail.suiteName || deviceDetail.roomName) && (
					<p className="device-location-info">
						{deviceDetail.suiteName && (
							<span>Süit: {deviceDetail.suiteName}</span>
						)}
						{deviceDetail.suiteName && deviceDetail.roomName && (
							<span className="separator"> • </span>
						)}
						{deviceDetail.roomName && <span>Oda: {deviceDetail.roomName}</span>}
					</p>
				)}
				{/* -------- HR MODAL (NEW) -------- */}
				<Modal
					show={hrModal}
					onHide={() => setHrModal(false)}
					centered
					size="lg"
				>
					<Modal.Body>
						<div className="d-flex justify-content-center align-items-center gap-4">
							<h4 className="fw-bold">Kalp Atış Hızı</h4>
							<Form.Check
								type="switch"
								id="hr-thresholds-switch"
								checked={hrConfig.state}
								onChange={() =>
									setHrConfig((prev) => ({ ...prev, state: !prev.state }))
								}
							/>
						</div>

						<Form>
							<div className="mb-3">
								<Form.Check
									style={{ display: "flex" }}
									type="radio"
									name="hr-profile"
									id="hr-low"
									label={
										<span>
											<strong>Düşük Seviye Risk</strong>{" "}
											<span className="text-muted ms-2">
												Kalp atış hızı 120 bpm'nin üzerinde veya 45 bpm'nin
												altında olduğunda uyar.
											</span>
										</span>
									}
									value="low"
									checked={hrConfig.profile === "low"}
									onChange={(e) =>
										setHrConfig((prev) => ({
											...prev,
											profile: e.target.value,
										}))
									}
								/>

								<Form.Check
									style={{ display: "flex" }}
									className="mt-3"
									type="radio"
									name="hr-profile"
									id="hr-medium"
									label={
										<span>
											<strong>Orta Seviye Risk</strong>{" "}
											<span className="text-muted ms-2">
												Kalp atış hızı 115 bpm'nin üzerinde veya 50 bpm'nin
												altında olduğunda uyar.
											</span>
										</span>
									}
									value="medium"
									checked={hrConfig.profile === "med"}
									onChange={(e) =>
										setHrConfig((prev) => ({
											...prev,
											profile: e.target.value,
										}))
									}
								/>

								<Form.Check
									style={{ display: "flex" }}
									className="mt-3"
									type="radio"
									name="hr-profile"
									id="hr-high"
									label={
										<span>
											<strong>Yüksek Seviye Risk</strong>{" "}
											<span className="text-muted ms-2">
												Kalp atış hızı 110 bpm'nin üzerinde veya 55 bpm'nin
												altında olduğunda uyar.
											</span>
										</span>
									}
									value="high"
									checked={hrConfig.profile === "high"}
									onChange={(e) =>
										setHrConfig((prev) => ({
											...prev,
											profile: e.target.value,
										}))
									}
								/>

								<Form.Check
									className="mt-3"
									type="radio"
									name="hr-profile"
									id="hr-custom"
									label={<strong>Özel Uyarı</strong>}
									value="custom"
									checked={hrConfig.profile === "custom"}
									onChange={(e) =>
										setHrConfig((prev) => ({
											...prev,
											profile: e.target.value,
										}))
									}
								/>
							</div>

							{/* Dual range (lower / upper). Custom dışındaki profillerde disabled görünür */}
							<div
								className="mt-3"
								style={
									hrConfig.profile !== "custom"
										? { opacity: 0.5, pointerEvents: "none" }
										: undefined
								}
							>
								<div className="d-flex justify-content-between text-muted mb-2">
									<span>{hrConfig.lowerBpm} bpm</span>
									<span>{hrConfig.upperBpm} bpm</span>
								</div>

								<Range
									values={[hrConfig.lowerBpm, hrConfig.upperBpm]}
									step={HR_STEP}
									min={HR_MIN}
									max={HR_MAX}
									onChange={(vals) => {
										let [low, up] = vals;
										// min gap koruması
										if (up - low < HR_MIN_GAP) {
											if (low !== hrConfig.lowerBpm) {
												low = Math.min(up - HR_MIN_GAP, up - 1);
											} else {
												up = Math.max(low + HR_MIN_GAP, low + 1);
											}
										}
										setHrConfig((prev) => ({
											...prev,
											lowerBpm: low,
											upperBpm: up,
										}));
									}}
									renderTrack={({ props, children }) => (
										<div
											onMouseDown={props.onMouseDown}
											onTouchStart={props.onTouchStart}
											style={{ height: "36px", display: "flex", width: "100%" }}
										>
											<div
												ref={props.ref}
												style={{
													height: "6px",
													width: "100%",
													borderRadius: "4px",
													background: `linear-gradient(
              to right,
              #dee2e6 0%,
              #dee2e6 ${pct(hrConfig.lowerBpm)}%,
              #0d6efd ${pct(hrConfig.lowerBpm)}%,
              #0d6efd ${pct(hrConfig.upperBpm)}%,
              #dee2e6 ${pct(hrConfig.upperBpm)}%,
              #dee2e6 100%
            )`,
													alignSelf: "center",
												}}
											>
												{children}
											</div>
										</div>
									)}
									renderThumb={({ props, index }) => (
										<div
											{...props}
											style={{
												...props.style,
												height: "20px",
												width: "20px",
												borderRadius: "50%",
												backgroundColor: "#fff",
												border: "2px solid #0d6efd",
												boxShadow: "0 0 0 2px rgba(13,110,253,0.15)",
												display: "flex",
												alignItems: "center",
												justifyContent: "center",
											}}
										>
											<div
												style={{
													position: "absolute",
													top: "-26px",
													fontSize: "12px",
													color: "#6c757d",
													whiteSpace: "nowrap",
												}}
											>
												{index === 0
													? `${hrConfig.lowerBpm}`
													: `${hrConfig.upperBpm}`}
											</div>
										</div>
									)}
								/>
							</div>
						</Form>
					</Modal.Body>

					<Modal.Footer>
						<Button variant="light" onClick={() => setHrModal(false)}>
							İptal
						</Button>
						<Button variant="primary" onClick={updateHrThresholds}>
							Kaydet
						</Button>
					</Modal.Footer>
				</Modal>

				{/* -------- RR MODAL (NEW) -------- */}
				<Modal
					show={rrModal}
					onHide={() => setRrModal(false)}
					centered
					size="lg"
				>
					<Modal.Body>
						<div className="d-flex justify-content-center align-items-center gap-4">
							<h4 className="fw-bold">Solunum Hızı</h4>
							<Form.Check
								type="switch"
								id="rr-thresholds-switch"
								checked={rrConfig.state}
								onChange={() =>
									setRrConfig((prev) => ({ ...prev, state: !prev.state }))
								}
							/>
						</div>

						<Form>
							<div className="mb-3">
								<Form.Check
									style={{ display: "flex" }}
									type="radio"
									name="rr-profile"
									id="rr-low"
									label={
										<span>
											<strong>Düşük Seviye Risk</strong>{" "}
											<span className="text-muted ms-2">
												Solunum hızı 40 rpm'nin üzerinde veya 6 rpm'nin altında
												olduğunda uyarır.
											</span>
										</span>
									}
									value="low"
									checked={rrConfig.profile === "low"}
									onChange={(e) =>
										setRrConfig((prev) => ({
											...prev,
											profile: e.target.value,
										}))
									}
								/>

								<Form.Check
									style={{ display: "flex" }}
									className="mt-3"
									type="radio"
									name="rr-profile"
									id="rr-medium"
									label={
										<span>
											<strong>Orta Seviye Risk</strong>{" "}
											<span className="text-muted ms-2">
												Solunum hızı 35 rpm'nin üzerinde veya 7 rpm'nin altında
												olduğunda uyarır.
											</span>
										</span>
									}
									value="medium"
									checked={rrConfig.profile === "med"}
									onChange={(e) =>
										setRrConfig((prev) => ({
											...prev,
											profile: e.target.value,
										}))
									}
								/>

								<Form.Check
									style={{ display: "flex" }}
									className="mt-3"
									type="radio"
									name="rr-profile"
									id="rr-high"
									label={
										<span>
											<strong>Yüksek Seviye Risk</strong>{" "}
											<span className="text-muted ms-2">
												Solunum hızı 30 rpm'nin üzerinde veya 7 rpm'nin altında
												olduğunda uyarır.
											</span>
										</span>
									}
									value="high"
									checked={rrConfig.profile === "high"}
									onChange={(e) =>
										setRrConfig((prev) => ({
											...prev,
											profile: e.target.value,
										}))
									}
								/>

								<Form.Check
									className="mt-3"
									type="radio"
									name="rr-profile"
									id="rr-custom"
									label={<strong>Özel Uyarı</strong>}
									value="custom"
									checked={rrConfig.profile === "custom"}
									onChange={(e) =>
										setRrConfig((prev) => ({
											...prev,
											profile: e.target.value,
										}))
									}
								/>
							</div>

							{/* --- RR RANGE / PRESET GÖRÜNÜMÜ --- */}
							{rrConfig.profile === "custom" ? (
								<>
									<div className="d-flex justify-content-between text-muted mb-2">
										<span>{Math.min(rrConfig.lower, rrConfig.upper)} rpm</span>
										<span>{Math.max(rrConfig.lower, rrConfig.upper)} rpm</span>
									</div>

									<Range
										values={[
											Math.min(rrConfig.lower, rrConfig.upper),
											Math.max(rrConfig.lower, rrConfig.upper),
										]}
										step={RR_STEP}
										min={RR_MIN}
										max={RR_MAX}
										onChange={(vals) => {
											let [low, up] = vals;
											if (up - low < RR_MIN_GAP) {
												if (low !== rrConfig.lower) {
													low = Math.min(up - RR_MIN_GAP, up - 1);
												} else {
													up = Math.max(low + RR_MIN_GAP, low + 1);
												}
											}
											setRrConfig((prev) => ({
												...prev,
												lower: Math.min(low, up),
												upper: Math.max(low, up),
												thresholds: {
													low: [
														{
															...(prev.thresholds?.low?.[0] || {
																minimumDurationSeconds: 15,
																type: null,
															}),
															limit: Math.min(low, up),
														},
													],
													high: [
														{
															...(prev.thresholds?.high?.[0] || {
																minimumDurationSeconds: 15,
																type: null,
															}),
															limit: Math.max(low, up),
														},
													],
												},
											}));
										}}
										renderTrack={({ props, children }) => (
											<div
												onMouseDown={props.onMouseDown}
												onTouchStart={props.onTouchStart}
												style={{
													height: "36px",
													display: "flex",
													width: "100%",
												}}
											>
												<div
													ref={props.ref}
													style={{
														height: "6px",
														width: "100%",
														borderRadius: "4px",
														background: `linear-gradient(
                to right,
                #dee2e6 0%,
                #dee2e6 ${pctRR(rrConfig.lower)}%,
                #0d6efd ${pctRR(rrConfig.lower)}%,
                #0d6efd ${pctRR(rrConfig.upper)}%,
                #dee2e6 ${pctRR(rrConfig.upper)}%,
                #dee2e6 100%
              )`,
														alignSelf: "center",
													}}
												>
													{children}
												</div>
											</div>
										)}
										renderThumb={({ props, index }) => (
											<div
												{...props}
												style={{
													...props.style,
													height: "20px",
													width: "20px",
													borderRadius: "50%",
													backgroundColor: "#fff",
													border: "2px solid #0d6efd",
													boxShadow: "0 0 0 2px rgba(13,110,253,0.15)",
													display: "flex",
													alignItems: "center",
													justifyContent: "center",
												}}
											>
												<div
													style={{
														position: "absolute",
														top: "-26px",
														fontSize: "12px",
														color: "#6c757d",
														whiteSpace: "nowrap",
													}}
												>
													{index === 0
														? `${Math.min(rrConfig.lower, rrConfig.upper)}`
														: `${Math.max(rrConfig.lower, rrConfig.upper)}`}
												</div>
											</div>
										)}
									/>
								</>
							) : (
								<div className="mt-3 p-2 rounded border bg-light text-muted"></div>
							)}
						</Form>
					</Modal.Body>

					<Modal.Footer>
						<Button variant="light" onClick={() => setRrModal(false)}>
							İptal
						</Button>
						<Button variant="primary" onClick={updateRrThresholds}>
							Kaydet
						</Button>
					</Modal.Footer>
				</Modal>

				{/* -------- DÜŞME MODAL -------- */}
				<Modal
					show={fallModal}
					onHide={() => setFallModal(false)}
					centered
					size="lg"
				>
					<Modal.Body>
						<div className="d-flex justify-content-center align-items-center gap-4">
							<h4 className="fw-bold">Düşme Bildirimi</h4>
							<Form.Check
								type="switch"
								id="fall-prevention-switch"
								checked={fallConfig.state}
								onChange={() =>
									setFallConfig((prev) => ({ ...prev, state: !prev.state }))
								}
							/>
						</div>

						<Form>
							<div className="mb-3">
								<div>
									<Form.Check
										type="radio"
										label={
											<>
												<strong>Düşük Risk</strong>{" "}
											</>
										}
										name="risk"
										value="low"
										checked={fallConfig.profile === "low"}
										onChange={(e) =>
											setFallConfig((prev) => ({
												...prev,
												profile: e.target.value,
											}))
										}
									/>
									<span
										className="text-muted d-block"
										style={{ fontWeight: "normal" }}
									>
										Yatakta{" "}
										{Math.round(fallConfig.minimumTimeInBedSeconds / 60)} dakika
										kaldıktan sonra, sakin uyku saatleri (7:30 akşam - 7:30
										sabah ve 1:30 öğleden sonra - 4:30 öğleden sonra) sırasında
										yataktan çıkmaya çalışmadan önce erken uyarı.
									</span>
								</div>

								<div>
									<Form.Check
										type="radio"
										label={
											<>
												<strong>Yüksek Risk</strong>{" "}
											</>
										}
										name="risk"
										value="high"
										checked={fallConfig.profile === "high"}
										onChange={(e) =>
											setFallConfig((prev) => ({
												...prev,
												profile: e.target.value,
											}))
										}
										className="mt-3"
									/>
									<span
										className="text-muted d-block"
										style={{ fontWeight: "normal" }}
									>
										Sakin, bakım saatleri (sabah 7:30 - 9:00 ve akşam 4:30 -
										5:30) dışında, yatakta{" "}
										{Math.round(fallConfig.minimumTimeInBedSeconds / 60)} dakika
										kaldıktan sonra yataktan çıkmaya çalışmadan önce erken
										uyarı.
									</span>
								</div>
							</div>

							<hr />

							<Form.Label>
								Uyarının üretilmesi için yatakta geçirilen minimum süreyi seçin
							</Form.Label>
							<Form.Range
								min={0}
								max={20}
								value={Math.floor(fallConfig.minimumTimeInBedSeconds / 60)}
								onChange={(e) =>
									setFallConfig((prev) => ({
										...prev,
										minimumTimeInBedSeconds: parseInt(e.target.value, 10) * 60,
									}))
								}
								style={{ appearance: "revert" }}
							/>

							<div className="d-flex justify-content-between text-muted">
								<span>0</span>
								<span>
									{Math.floor(fallConfig.minimumTimeInBedSeconds / 60)} dakika
								</span>
								<span>20 dakika</span>
							</div>
						</Form>
					</Modal.Body>
					<Modal.Footer>
						<Button variant="light" onClick={() => setFallModal(false)}>
							İptal
						</Button>
						<Button variant="primary" onClick={updateFallSettings}>
							Kaydet
						</Button>
					</Modal.Footer>
				</Modal>

				{/* -------- Yatak Doluluk Modal -------- */}
				<Modal
					show={postureModal}
					onHide={() => setPostureModal(false)}
					centered
					size="lg"
				>
					<Modal.Header closeButton>
						<Modal.Title>Yatak Doluluk</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<Form>
							{/* In Bed Section */}
							<div className="mb-4">
								<div className="d-flex justify-content-between align-items-center mb-2">
									<div>
										<h5 className="mb-1">Yatakta</h5>
										<p className="text-muted mb-0" style={{ fontSize: "14px" }}>
											Kişi yatağa girdiğinde uyarı ver
										</p>
									</div>
									<Form.Check
										type="switch"
										id="in-bed-switch"
										checked={postureConfig.inBed.enabled}
										onChange={() =>
											setPostureConfig((prev) => ({
												...prev,
												inBed: {
													...prev.inBed,
													enabled: !prev.inBed.enabled,
												},
											}))
										}
									/>
								</div>
								<Form.Check
									type="checkbox"
									id="in-bed-sleep-time"
									label="Sadece uyku saatlerinde"
									checked={postureConfig.inBed.onlyDuringSleepTime}
									onChange={() =>
										setPostureConfig((prev) => ({
											...prev,
											inBed: {
												...prev.inBed,
												onlyDuringSleepTime:
													!prev.inBed.onlyDuringSleepTime,
											},
										}))
									}
									className="ms-4"
								/>
								<div className="ms-4 mt-1 text-muted" style={{ fontSize: "13px" }}>
									uyku saatleri{" "}
									{postureConfig.sleepTime.periods
										.map(
											(p) =>
												`${formatSleepTime(p.start)} - ${formatSleepTime(p.end)}`
										)
										.join(" ve ")}
								</div>
							</div>

							<hr />

							{/* Out of Bed Section */}
							<div className="mb-4">
								<div className="d-flex justify-content-between align-items-center mb-2">
									<div>
										<h5 className="mb-1">Yataktan Çıkış</h5>
										<p className="text-muted mb-0" style={{ fontSize: "14px" }}>
											Kişi yataktan çıktığında uyarı ver
										</p>
									</div>
									<Form.Check
										type="switch"
										id="out-of-bed-switch"
										checked={postureConfig.outOfBed.enabled}
										onChange={() =>
											setPostureConfig((prev) => ({
												...prev,
												outOfBed: {
													...prev.outOfBed,
													enabled: !prev.outOfBed.enabled,
												},
											}))
										}
									/>
								</div>
								<Form.Check
									type="checkbox"
									id="out-of-bed-sleep-time"
									label="Sadece uyku saatlerinde"
									checked={postureConfig.outOfBed.onlyDuringSleepTime}
									onChange={() =>
										setPostureConfig((prev) => ({
											...prev,
											outOfBed: {
												...prev.outOfBed,
												onlyDuringSleepTime:
													!prev.outOfBed.onlyDuringSleepTime,
											},
										}))
									}
									className="ms-4"
								/>
								<div className="ms-4 mt-1 text-muted" style={{ fontSize: "13px" }}>
									uyku saatleri{" "}
									{postureConfig.sleepTime.periods
										.map(
											(p) =>
												`${formatSleepTime(p.start)} - ${formatSleepTime(p.end)}`
										)
										.join(" ve ")}
								</div>
							</div>

							<hr />

							{/* Away from Bed Section */}
							<div className="mb-4">
								<div className="d-flex justify-content-between align-items-center mb-2">
									<div>
										<h5 className="mb-1">Yataktan Uzak</h5>
										<p className="text-muted mb-0" style={{ fontSize: "14px" }}>
											Kişi yatağa dönmediğinde uyarı ver:
										</p>
									</div>
									<Form.Check
										type="switch"
										id="away-from-bed-switch"
										checked={postureConfig.awayFromBed.enabled}
										onChange={() =>
											setPostureConfig((prev) => ({
												...prev,
												awayFromBed: {
													...prev.awayFromBed,
													enabled: !prev.awayFromBed.enabled,
												},
											}))
										}
									/>
								</div>
								<Form.Check
									type="checkbox"
									id="away-from-bed-sleep-time"
									label="Sadece uyku saatlerinde"
									checked={postureConfig.awayFromBed.onlyDuringSleepTime}
									onChange={() =>
										setPostureConfig((prev) => ({
											...prev,
											awayFromBed: {
												...prev.awayFromBed,
												onlyDuringSleepTime:
													!prev.awayFromBed.onlyDuringSleepTime,
											},
										}))
									}
									className="ms-4"
								/>
								<div className="ms-4 mt-1 text-muted" style={{ fontSize: "13px" }}>
									uyku saatleri{" "}
									{postureConfig.sleepTime.periods
										.map(
											(p) =>
												`${formatSleepTime(p.start)} - ${formatSleepTime(p.end)}`
										)
										.join(" ve ")}
								</div>
								<div className="ms-4 mt-3">
									<Form.Range
										min={1}
										max={120}
										value={postureConfig.awayFromBed.delayMinutes}
										onChange={(e) =>
											setPostureConfig((prev) => ({
												...prev,
												awayFromBed: {
													...prev.awayFromBed,
													delayMinutes: parseInt(e.target.value, 10),
												},
											}))
										}
										style={{ appearance: "revert" }}
									/>
									<div className="d-flex justify-content-between text-muted mt-1">
										<span>1 dakika</span>
										<span>{postureConfig.awayFromBed.delayMinutes} dakika</span>
										<span>120 dakika</span>
									</div>
								</div>
							</div>

							<hr />

							{/* Minimum Time in Bed */}
							<div className="mb-3">
								<Form.Label>
									<strong>
										"Yataktan Çıkış" ve "Yataktan Uzak" uyarılarının
										üretilmesi için yatakta geçirilen minimum süreyi seçin:
									</strong>
								</Form.Label>
								<Form.Range
									min={1}
									max={20}
									value={postureConfig.minimumTimeInBedMinutes}
									onChange={(e) =>
										setPostureConfig((prev) => ({
											...prev,
											minimumTimeInBedMinutes: parseInt(e.target.value, 10),
										}))
									}
									style={{ appearance: "revert" }}
								/>
								<div className="d-flex justify-content-between text-muted mt-1">
									<span>1 dakika</span>
									<span>{postureConfig.minimumTimeInBedMinutes} dakika</span>
									<span>20 dakika</span>
								</div>
							</div>
						</Form>
					</Modal.Body>
					<Modal.Footer>
						<Button variant="light" onClick={() => setPostureModal(false)}>
							İptal
						</Button>
						<Button variant="primary" onClick={updatePostureSettings}>
							Kaydet
						</Button>
					</Modal.Footer>
				</Modal>

				{/* -------- Success Modal -------- */}
				<Modal
					show={successModal}
					onHide={() => setSuccessModal(false)}
					centered
					size="sm"
				>
					<Modal.Body className="text-center py-4">
						<div className="mb-3">
							<svg
								width="64"
								height="64"
								viewBox="0 0 64 64"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
								style={{ color: "#28a745" }}
							>
								<circle cx="32" cy="32" r="30" fill="#28a745" opacity="0.1" />
								<path
									d="M32 8C18.745 8 8 18.745 8 32s10.745 24 24 24 24-10.745 24-24S45.255 8 32 8zm-2.343 32.485l-8.485-8.485 2.828-2.828 5.657 5.657 12.728-12.728 2.828 2.828-15.556 15.556z"
									fill="#28a745"
								/>
							</svg>
						</div>
						<h5 className="mb-3" style={{ color: "#28a745" }}>
							Başarılı!
						</h5>
						<p className="mb-0">{successMessage}</p>
					</Modal.Body>
					<Modal.Footer className="justify-content-center">
						<Button
							variant="success"
							onClick={() => setSuccessModal(false)}
						>
							Tamam
						</Button>
					</Modal.Footer>
				</Modal>

				{/* -------- Duruş Modal -------- */}
				<Modal
					show={pressureUlcersModal}
					onHide={() => setPressureUlcersModal(false)}
					centered
					size="lg"
				>
					<Modal.Body>
						<div className="d-flex justify-content-center align-items-center gap-4 mb-4">
							<h4 className="fw-bold">Duruş Değişikliği</h4>
							<Form.Check
								type="switch"
								id="pressure-ulcers-switch"
								checked={pressureUlcersConfig.state}
								onChange={() =>
									setPressureUlcersConfig((prev) => ({
										...prev,
										state: !prev.state,
									}))
								}
							/>
						</div>

						<Form>
							<Form.Group className="mb-3">
								<div className="mb-3">
									<div style={{ display: "flex", gap: "20px" }}>
										<Form.Check
											type="radio"
											label={
												<>
													<strong>2 Saat</strong>{" "}
												</>
											}
											name="risk"
											value="2hrs"
											checked={pressureUlcersConfig.profile === "2hrs"}
											onChange={(e) =>
												setPressureUlcersConfig((prev) => ({
													...prev,
													profile: e.target.value,
												}))
											}
										/>
										<span
											className="text-muted d-block"
											style={{ fontWeight: "normal" }}
										>
											Yatakta her 2 saatte bir çevirme hatırlatıcısı.
										</span>
									</div>

									<div style={{ display: "flex", gap: "10px" }}>
										<Form.Check
											type="radio"
											label={
												<>
													<strong>3 Saat</strong>{" "}
												</>
											}
											name="risk"
											value="3hrs"
											checked={pressureUlcersConfig.profile === "3hrs"}
											onChange={(e) =>
												setPressureUlcersConfig((prev) => ({
													...prev,
													profile: e.target.value,
												}))
											}
										/>
										<span
											className="text-muted d-block"
											style={{ fontWeight: "normal" }}
										>
											Yatakta her 3 saatte bir çevirme hatırlatıcısı.
										</span>
									</div>
								</div>
							</Form.Group>

							<Form.Check
								type="checkbox"
								label="Sadece hasta hareketsiz kaldığında alarm ver"
								checked={pressureUlcersConfig.onlyIfStatic}
								onChange={() =>
									setPressureUlcersConfig((prev) => ({
										...prev,
										onlyIfStatic: !prev.onlyIfStatic,
									}))
								}
							/>
						</Form>
					</Modal.Body>

					<Modal.Footer>
						<Button
							variant="light"
							onClick={() => setPressureUlcersModal(false)}
						>
							İptal
						</Button>
						<Button variant="primary" onClick={updatePressureUlcersSettings}>
							Kaydet
						</Button>
					</Modal.Footer>
				</Modal>

				<div className="activities">
					<div className="container">
						<h2>Aktiviteler</h2>
						<div className="icon-grid">
							{activities.map((activity, index) => (
								<div
									key={index}
									className={`icon ${
										selectedActivityIndex === index ? "active" : ""
									}`}
									onClick={() => setSelectedActivityIndex(index)}
									title={activity.name}
								>
									{activity.icon}
								</div>
							))}
						</div>

						<h3 className="section-title">
							{currentActivity.icon} {currentActivity.name}
						</h3>

						<Tabs
							defaultActiveKey="home"
							id="uncontrolled-tab-example"
							className="mb-3"
						>
							<Tab eventKey="home" title="Aktivite Ekle">
								<div className="form-group">
									<label>Tarih:</label>
									<input
										type="date"
										value={startDate}
										onChange={(e) => setStartDate(e.target.value)}
									/>
								</div>

								<div className="form-group">
									<label>Saat:</label>

									<input
										type="time"
										value={times}
										onChange={(e) => setTimes(e.target.value)}
										className="time-input"
									/>
								</div>

								<div className="form-group">
									<label>Açıklama:</label>
									<input
										type="input"
										value={desc}
										onChange={(e) => setDesc(e.target.value)}
									/>
								</div>
							</Tab>

							<Tab eventKey="profile" title="Hatırlatıcı Ekle">
								<div className="max-w-md mx-auto p-4 bg-white rounded-lg shadow">
									<div className="mb-4">
										<label className="block text-gray-700 mb-1">
											Başlangıç tarihi
										</label>
										<input
											type="date"
											value={startDate}
											onChange={(e) => setStartDate(e.target.value)}
											className="border rounded w-full p-2"
										/>
									</div>

									<div className="mb-4">
										<label className="block text-gray-700 mb-1">
											Tekrar Zamanı
										</label>
										<select
											value={repeat}
											onChange={(e) => setRepeat(e.target.value)}
											className="border rounded w-full p-2"
										>
											<option value="Haftalık">Haftalık</option>
											<option value="Günlük">Günlük</option>
											<option value="Aylık">Aylık</option>
										</select>
									</div>

									{repeat !== "Günlük" && (
										<div className="mb-4 flex space-x-2 box-wrapper">
											{days.map((day, idx) => (
												<button
													key={idx}
													onClick={() => toggleDay(day)}
													className={`w-8 h-8 rounded-full day-box ${
														selectedDays.includes(day)
															? "selected"
															: "bg-gray-200 text-gray-700"
													}`}
												>
													{day}
												</button>
											))}
										</div>
									)}

									<div className="mb-4">
										{time?.map((t, index) => (
											<input
												key={index}
												type="time"
												value={t}
												onChange={(e) =>
													handleReminderTimeChange(index, e.target.value)
												}
												className="border rounded w-full p-2 mb-2"
											/>
										))}
									</div>

									<div
										onClick={addTime}
										className="text-blue-600 text-sm cursor-pointer hover:underline"
									>
										+ Ek süre ekleyin
									</div>

									<button className="mt-4 save-btn" onClick={addReminder}>
										Hatırlatıcı Ekle
									</button>
								</div>
							</Tab>
						</Tabs>

						<div className="button-group">
							<button className="save-btn" onClick={addActivity}>
								Kaydet
							</button>
						</div>
					</div>
					<div>
						<div className="alarms">
							<div className="icons">
								<div onClick={() => setFallModal(true)}>
									<FaPersonFalling />
								</div>
								<div onClick={() => setPressureUlcersModal(true)}>
									<FaPeopleArrows />
								</div>
								<div onClick={() => setHrModal(true)}>
									<PiHeartbeatFill />
								</div>
								<div onClick={() => setRrModal(true)}>
									<BsFillLungsFill />
								</div>
								<div onClick={() => setPostureModal(true)}>
                  <FaBed />
								</div>
							</div>
						</div>
						<div className="activity-table">
							<Table striped bordered hover responsive className="alarm-table">
								<thead>
									<tr>
										<th>Aktivite Tipi</th>
										<th>Tarih</th>
										<th>Saat</th>
										<th>Açıklama</th>
										<th>Kullanıcı</th>
									</tr>
								</thead>
								<tbody>
									{activitiesData?.map((data, index) => (
										<tr key={index}>
											<td>{data.type}</td>
											<td>{data.date}</td>
											<td>{data.aTime}</td>
											<td>{data.desc}</td>
											<td>{data.user}</td>
										</tr>
									))}
								</tbody>
							</Table>
						</div>
						<div className="activity-table mt-4">
							<h5 className="mb-3">Vital Değişiklik Logları</h5>
							<Table striped bordered hover responsive className="alarm-table">
								<thead>
									<tr>
										<th>Değişim Türü</th>
										<th>Önceki Değer</th>
										<th>Yeni Değer</th>
										<th>Kullanıcı</th>
										<th>Tarih</th>
									</tr>
								</thead>
								<tbody>
									{vitalLogs?.length > 0 ? (
										vitalLogs.map((log, index) => {
											let changeTypeName = "";
											switch (log.changeType) {
												case "fall":
													changeTypeName = "Düşme";
													break;
												case "pressureUlcers":
													changeTypeName = "Duruş Değişikliği";
													break;
												case "hr":
													changeTypeName = "Kalp Atış Hızı";
													break;
												case "rr":
													changeTypeName = "Solunum Hızı";
													break;
											case "posture":
												changeTypeName = "Yatak Doluluk";
													break;
												default:
													changeTypeName = log.changeType;
											}

											const logDate = new Date(log.createdAt);
											const formattedDate = logDate.toLocaleDateString(
												"tr-TR",
												{
													year: "numeric",
													month: "2-digit",
													day: "2-digit",
													hour: "2-digit",
													minute: "2-digit",
												}
											);

											return (
												<tr key={index}>
													<td>{changeTypeName}</td>
													<td style={{ maxWidth: "350px", padding: "10px" }}>
														{formatVitalValue(
															log.previousValue,
															log.changeType
														)}
													</td>
													<td style={{ maxWidth: "350px", padding: "10px" }}>
														{formatVitalValue(log.newValue, log.changeType)}
													</td>
													<td>{log.user}</td>
													<td>{formattedDate}</td>
												</tr>
											);
										})
									) : (
										<tr>
											<td colSpan="5" className="text-center text-muted">
												Henüz log kaydı bulunmamaktadır.
											</td>
										</tr>
									)}
								</tbody>
							</Table>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default Activities;
